module.exports = __webpack_public_path__ + "static/media/5DPO16.6923a8c1.jpg";